import React, { createContext, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faExclamationCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import "./Notify.css"

const NotifyContext = createContext()

function useNotify(){
    const [text, setText] = useState('This is notification')
    const [description, setDescription] = useState("This is description appear here.")
    const [priority, setPriority] = useState(0);
    const [isShow, setShow] = useState(false)

    const showNotify = (message, descriptionMessage, priorityLevel) =>{
        setShow(true)
        setText(message)
        setDescription(descriptionMessage)
        setPriority(priorityLevel)
        setTimeout(()=>{
            setShow(false)
        }, 3300)
    }

    return { text, isShow, priority, showNotify, description }
}

function NotifyModal(props){
    let icon = faCheckCircle
    let color = "green"

    if(props.priority === 1){
        icon = faExclamationCircle
        color = "orange"
    }else if(props.priority){
        icon = faTimesCircle
        color = "red"
    }

    return(
        <div className="notify" 
        style={{
            top: props.isShow ? 0 : -200
        }}
        >
            <FontAwesomeIcon 
            color={color}
            icon={icon} 
            className="icon"/>
            <div>
                <b className="title">{props.title}</b>
                <div className="description">{props.description}</div>
            </div>
        </div>
    )
}

function NotifyProvider(props){
    const notify = useNotify()

    return(
        <NotifyContext.Provider value={notify}>
            <NotifyModal 
            title={notify.text} 
            isShow={notify.isShow}
            priority={notify.priority}
            description={notify.description}/>
            {props.children}
        </NotifyContext.Provider>
    )
}

export { NotifyProvider, NotifyContext }